<template lang="pug">
  div.waste-generators.bank-books-legal-update
    e-form-modal(
    ref="modalForm"
    @submitModalForm="sendForm()"
    @deleteItem="deleteItem()"
    :hideDeleteButton="(!!fields.id)"
    )
      div(slot="header")
        e-breadcrumbs
        h1.title {{formTitle}}
        e-form-tabs(
        v-model="tabView"
        :tabs="[{tab1: 'Общие сведения'},{operations: 'Операции'},{invoices: 'Квитанции'}]"
        )
      slot
        e-form(:formValidator="formValidator")
          // вкладка ОБЩИЕ СВЕДЕНИЯ
          div(v-show="tabView === 'tab1'")
            div.body
              div.col
                e-form-subtitle(text="Реквизиты")

                e-form-group(
                name="number"
                inputType="input"
                label="Номер лицевого счета"
                :model="fields"
                tabView="tab1"
                :disabled="true"
                )

                e-form-group(
                name="status_id"
                inputType="select"
                label="Статус"
                :model="fields"
                tabView="tab1"
                :options="statuses"
                :required="true"
                @change="onStatusChange($event)"
                )

                e-form-group(
                name="sba_id"
                inputType="input"
                label="Единый лицевой счет"
                :model="fields"
                tabView="tab1"
                :disabled="true"
                )

                e-form-group(
                name="hcs_id"
                inputType="input"
                label="Идентификатор ЖКУ"
                :model="fields"
                tabView="tab1"
                :disabled="true"
                )

                div.col-sub-cols-2
                  e-form-group(
                  name="opened_at"
                  inputType="calendar"
                  type="date"
                  label="Дата открытия счета"
                  :model="fields"
                  tabView="tab1"
                  :required="true"
                  )
                  e-form-group(
                  name="end"
                  inputType="calendar"
                  label="Дата закрытия"
                  type="date"
                  :model="fields"
                  tabView="tab1"
                  :required="fields.status_id == notActive"
                  :disabled="fields.status_id != notActive"
                  )

                e-form-group(
                name="closing_reason"
                inputType="input"
                label="Причина закрытия"
                :model="fields"
                tabView="tab1"
                :required="fields.status_id == notActive"
                :disabled="fields.status_id != notActive"
                )

                e-form-group(
                name="note"
                inputType="input"
                label="Примечание"
                :model="fields"
                tabView="tab1"
                :disabled="fields.status_id != notActive"
                )

              div.col
                e-form-subtitle(text="Сведения о владельце лицевого счета")
                e-form-group(
                name="name"
                inputType="input"
                label="Полное наименование организации"
                :model="parentItem"
                tabView="tab1"
                :disabled="true"
                )
                div.col-sub-cols-2
                  e-form-group(
                  name="inn"
                  inputType="input"
                  label="ИНН"
                  :model="parentItem"
                  tabView="tab1"
                  :disabled="true"
                  )
                  e-form-group(
                  name="kpp"
                  inputType="input"
                  label="КПП"
                  :model="parentItem"
                  tabView="tab1"
                  :disabled="true"
                  )
                e-form-group(
                name="ogrn"
                inputType="input"
                label="ОГРН/ОГРНИП потребителя"
                :model="parentItem"
                tabView="tab1"
                :disabled="true"
                )
                e-form-group(
                name="nza"
                inputType="input"
                label="НЗА потребителя"
                :model="parentItem"
                tabView="tab1"
                :disabled="true"
                )

              div.col
                e-form-subtitle(text="Сведения об источнике отходообразования")

                e-form-group(
                v-if="isEdit"
                name="address"
                :model="fields"
                tabView="tab1"
                :disabled="disabledInEditMode"
                )
                e-form-group(
                v-else
                name="address"
                inputType="address"
                addressProvider="tree"
                :model="fields"
                tabView="tab1"
                :required="true"
                :disabled="disabledInEditMode"
                )

                e-form-group(
                name="flat"
                inputType="input"
                label="Номер офиса"
                :model="fields"
                tabView="tab1"
                :required="false"
                :disabled="disabledInEditMode"
                )

                e-form-group(
                name="cause"
                inputType="input"
                label="Основание"
                :model="fields"
                tabView="tab1"
                )
                e-form-group(
                name="part"
                inputType="input"
                label="Доля собственности"
                :model="fields"
                tabView="tab1"
                :required="false"
                :validationAdditionalRules="partValidationRules"
                )
                e-form-group(
                name="square"
                inputType="input"
                label="Площадь помещения"
                :model="fields"
                tabView="tab1"
                :required="false"
                )

            bank-books-normatives(
            ref="bankBooksNormatives"
            :dataUrl="bankBooksNormativesDataUrl"
            :normativeType="NORMATIVE_TYPE_LEGAL"
            :formValidator="formValidator"
            :validate-alias="bankBookNormativeValidateAlias"
            tabView="tab1"
            :item="item"
              :fields="fields"
            :required="true"
            )

          div(v-show="tabView === 'operations'")
            bank-books-operations(
            :model="fields"
            )

          div(v-show="tabView === 'invoices'")
            bank-books-invoices(
            :model="fields"
            )

</template>

<script>
import { wasteGenerators, core } from '@/api/api-endpoints'
import billForm from './mixins/bill-form'
import BankBooksNormatives from './components/bank-books-normatives'
import BankBooksOperations from './components/bank-books-operations'
import BankBooksInvoices from './components/bank-books-invoices'

export default {
  name: 'bank-books-legal-update',
  components: { BankBooksInvoices, BankBooksOperations, BankBooksNormatives },
  mixins: [billForm],
  data() {
    return {
      tabView: 'tab1',
    }
  },
  methods: {
    getCollectionEndpoint() {
      return core.collection('billing_account_status,identity_card_type')
    },
    getDeleteUrl(id) {
      return wasteGenerators.bankBookLegalDelete(id)
    },
    getUpdateOrCreateUrl() {
      if (this.$route.params.objectId) {
        return wasteGenerators.bankBookLegalUpdate(this.$route.params.objectId)
      }
      return wasteGenerators.bankBookLegalCreate(this.$route.params.id)
    },
    getItemEndpoint(route) {
      if (!route.params.id || !route.params.objectId) {
        return null
      }
      return wasteGenerators.bankBookLegal(route.params.objectId)
    },
  },
}
</script>
